import React from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import TopHeader from "@/components/app/TopHeader";
import BottomNav from "@/components/app/BottomNav";
import ThemeProvider from "@/components/app/ThemeProvider";
import { auth } from "@/lib/api";

const titleForPath = (p) => {
  if (p === "/") return "Manager Dashboard";
  if (p.startsWith("/players")) return "Players Scout";
  if (p.startsWith("/fixtures")) return "Fixtures & FDR";
  if (p.startsWith("/my-team")) return "My Team";
  if (p.startsWith("/leagues") && p.includes("/diff")) return "Rival Diff";
  if (p.startsWith("/leagues")) return "Leagues";
  if (p.startsWith("/profile")) return "Profile";
  if (p.startsWith("/ask")) return "Ask FPL";
  if (p.startsWith("/compare")) return "Compare Players";
  if (p.startsWith("/rank-gap")) return "Rank Gap";
  if (p.startsWith("/live")) return "Live Rank";
  return "FPL Totem";
};

export default function AppShell() {
  const loc = useLocation();
  if (!auth.isLoggedIn()) return <Navigate to="/login" replace />;

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-totem-bg text-totem-text">
        <div className="mx-auto max-w-md">
          <TopHeader title={titleForPath(loc.pathname)} />
          <div className="team-accent-stripe" />
          <main className="pb-28 pt-2 px-4 min-h-[calc(100vh-4rem)]">
            <Outlet />
          </main>
          <BottomNav />
        </div>
      </div>
    </ThemeProvider>
  );
}
